import axios from "./axios";

const BASE_URL = '/api/mechanics/';

export default {
    methods: {
        getApiConfig () {
            let token = this.getApiToken();
            let config = {};

            if (token) { config.headers = {'Authorization': 'Bearer ' + token} }
            // console.log('TOKEN', token, config)
            return config
        },
        apiUpdate (url, data, blockUi = true) {
            let hash = 0;
            if (blockUi) hash = this.$root.blockUI();
            url = this.getApiUrl() + url;
            // let formData = new FormData()
            // for (let fld in data) {
            //     formData.append(fld, data[fld])
            // }
            return this.getAxiosInstanse().put(url, data, this.getApiConfig()).then((response) => {
                if (blockUi) this.$root.unblockUI(hash);
                return response;
            }).catch(error => {
                if (blockUi) this.$root.unblockUI(hash);
                throw error;
            })
        },
        apiPost (url, data, blockUi = true,) {
            let hash = 0;
            if (blockUi) hash = this.$root.blockUI();
            url = this.getApiUrl() + url;
            let formData = new FormData();
            for (let fld in data) {
                if (data[fld] || data[fld] === 0) formData.append(fld, data[fld])
            }
            return this.getAxiosInstanse().post(url, formData, this.getApiConfig()).then((response) => {
                if (blockUi) this.$root.unblockUI(hash);
                return response;
            }).catch(error => {
                if (blockUi) this.$root.unblockUI(hash);
                throw error;
            })
        },
        apiPostFormData (url, data, blockUi = true,) {
            let hash = 0;
            if (blockUi) hash = this.$root.blockUI();
            url = this.getApiUrl() + url;

            return this.getAxiosInstanse().post(url, data, this.getApiConfig()).then((response) => {
                if (blockUi) this.$root.unblockUI(hash);
                return response;
            }).catch(error => {
                if (blockUi) this.$root.unblockUI(hash);
                throw error;
            })
        },
        apiFile (url, data, blockUi = true) {
            let hash = 0;
            if (blockUi) hash = this.$root.blockUI();
            url = this.getApiUrl() + url;
            let formData = new FormData();
            for (let fld in data) {
                formData.append(fld, data[fld])
            }
            let config = this.getApiConfig();
            config.headers['Content-Type'] = 'multipart/form-data';
            return this.getAxiosInstanse().post(url, formData, config).then((response) => {
                if (blockUi) this.$root.unblockUI(hash);
                return response;
            }).catch(error => {
                if (blockUi) this.$root.unblockUI(hash);
                throw error;
            })
        },
        apiMultiFile (url, data, blockUi = true) {
            let hash = 0;
            if (blockUi) hash = this.$root.blockUI();
            url = this.getApiUrl() + url;
            let formData = new FormData();
            for (let fld in data) {
                if (Array.isArray(data[fld])) {
                    data[fld].forEach(file => formData.append(`${fld}[]`, file)); // Массив
                } else {
                    formData.append(fld, data[fld]);
                }
            }
            let config = this.getApiConfig();
            config.headers['Content-Type'] = 'multipart/form-data';
            return this.getAxiosInstanse().post(url, formData, config).then((response) => {
                if (blockUi) this.$root.unblockUI(hash);
                return response;
            }).catch(error => {
                if (blockUi) this.$root.unblockUI(hash);
                throw error;
            })
        },
        apiGet (url, data, blockUi = true, config = {}) {
            let hash = 0;
            if (blockUi) hash = this.$root.blockUI();
            url = this.getApiUrl() + url;
            return this.getAxiosInstanse().get(url, {
                ...this.getApiConfig(),
                ...config,
                params: data
            }).then((response) => {
                if (blockUi) this.$root.unblockUI(hash);
                return response;
            }).catch(error => {
                if (blockUi) this.$root.unblockUI(hash);
                throw error;
            })
        },
        apiDelete (url, data) {
            url = this.getApiUrl() + url;
            return this.getAxiosInstanse().delete(url, {
                ...this.getApiConfig(),
                params: data
            })
        },
        getApiToken () {
            return this.$ls.getItem('access_token');
        },
        getApiUrl () {
            return this.$store.state.baseUrl + BASE_URL;
        },
        getApiAuthUrl (subUrl = '') {
            return this.$store.state.baseUrl + BASE_URL + `${subUrl}?token=${this.getApiToken()}`;
        },
        refreshTokenForce() {
            return new Promise((resolve, reject) => {
                let endTime = this.$store.state.last_token_updated;
                let minutes = 0;

                if (endTime) {
                    let now = this.moment(),
                        end = this.moment(endTime*1000),
                        duration = this.moment.duration(now.diff(end));

                    minutes = duration.asMinutes();
                }

                if (!endTime || minutes >= 10) {
                    let url = this.$store.state.baseUrl + '/api/auth/refresh';
                    return this.getAxiosInstanse().get(url, {
                        ...this.getApiConfig(),
                    }).then((response) => {
                        let token = response.data.access_token;
                        this.$ls.setItem('access_token', token);
                        this.$store.dispatch('updateToken', this.moment().unix());
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                        this.$emit('token-refreshed', token);
                        resolve();

                    }).catch(error => {
                        reject(error);
                    })
                }

                resolve();
            });
        },
        getAxiosInstanse() {
            if (!this.$root._axios) {
                this.$root._axios = this.$root.initAxios();
            }
            return this.$root._axios;
        },
        apiTableGet (url, config, blockUi = true) {
            let hash = 0;
            if (blockUi) hash = this.$root.blockUI();
            url = this.getApiUrl() + url;
            return this.getAxiosInstanse().get(url, {
                ...this.getApiConfig(),
                ...config
            }).then((response) => {
                if (blockUi) this.$root.unblockUI(hash);
                return response;
            }).catch(error => {
                if (blockUi) this.$root.unblockUI(hash);
                throw error;
            })
        },
        getRawApiUrl (subUrl = '') {
            return this.$store.state.baseUrl + '/' + `${subUrl}?token=${this.getApiToken()}`;
        },
    }
}



// WEBPACK FOOTER //
// ./src/api.js